/** The warehouse's reorder points, and the control that adds one. */
import { Plus } from 'lucide-react';
import { useState } from 'react';

import type { WarehouseWithRelations } from '../../../api/warehouse';

import WarehouseReorderPointModal from './WarehouseReorderPointModal';
import WarehouseReorderPointsTable from './WarehouseReorderPointsTable';

export default function WarehouseReorderSection({
  warehouse,
  onRefresh,
}: {
  warehouse: WarehouseWithRelations;
  onRefresh: () => Promise<void>;
}) {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="space-y-4">
      <WarehouseReorderPointsTable
        warehouseId={warehouse.id}
        reorderPoints={warehouse.reorderPoints}
        onRefresh={onRefresh}
      />
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-stone-50 dark:hover:bg-[#242d28] transition"
      >
        <Plus size={14} />
        Add Reorder Point
      </button>
      {showModal && (
        <WarehouseReorderPointModal
          warehouseId={warehouse.id}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            void onRefresh();
          }}
        />
      )}
    </div>
  );
}
